
































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { formatNumber } from '@/utils/helpers';
import CartList from './CartList.vue';
import FoodDetail from './FoodDetail.vue';
import { cloneDeep } from 'lodash';
import api from '@/api';
import constants from '@/utils/constants';
@Component({
  components: {
    CartList,
    FoodDetail,
  },
  filters: {
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    },
  },
})
export default class PosOrder extends Vue {
  $swal: any;
  public selected: string = '';
  public tempSelected: string = '';
  public search: string = '';
  public tempSearch: string = '';
  public showCart: boolean = false;
  public showFoodDetail: boolean = false;
  public options: Array<any> = [];
  public selectedFood: object = {};
  public selectedMenuGroupCode: string = '';
  public loading: boolean = true;
  public isMobile: string = sessionStorage.getItem('isMobile') || '';
  public data: Array<any> = [];
  public originalData: Array<any> = [];
  public cartList: Array<any> = [];
  public orderType: string = '';
  public shortOrderType: string = '';
  public getIndex: Function = (data, MenuGroupCode, menuItemCode) => {
    let currentGroupIndex = data.findIndex(
      (item) => item.menuGroupCode === MenuGroupCode
    );
    let dataIndex = data[currentGroupIndex].menus.findIndex(
      (item) => item.menuItemCode === menuItemCode
    );
    return {
      currentGroupIndex,
      dataIndex,
    };
  };
  backHandle() {
    this.$router.push('/order-report');
  }
  showVariantsHandle(item, index) {
    item.showVariants = !item.showVariants;
  }
  filterData(data) {
    for (let i = 0; i < this.cartList.length; i++) {
      const element = this.cartList[i];
      const group = data.filter(
        (item) => item.menuGroupCode === element.menuGroupCode
      );
      for (let j = 0; j < group[0].menus.length; j++) {
        let item = group[0].menus[j];
        if (
          item.menuItemCode === element.menuItemCode &&
          (!element.variants || !element.variants.length)
        ) {
          item.num = element.num;
        }
      }
    }
    return data;
  }
  @Watch('selected')
  selectedGourp() {
    for (let i = 0; i < this.data.length; i++) {
      const item = this.data[i];
      item.show = true;
      for (let j = 0; j < item.menus.length; j++) {
        const element = item.menus[j];
        element.show = true;
      }
    }
    if (!this.selected) return;
    for (let i = 0; i < this.data.length; i++) {
      const item = this.data[i];
      item.show = true;
      if (item.menuGroupCode === this.selected) {
        item.show = true;
      } else {
        item.show = false;
      }
    }
  }
  @Watch('search')
  searchMenu() {
    if (this.selected) return;
    if (!this.search) {
      this.data = JSON.parse(
        JSON.stringify(this.data).replace(/"show":false/g, `"show":true`)
      );
      return;
    }
    try {
      for (let i = 0; i < this.data.length; i++) {
        const element = this.data[i];
        if (element.menus) {
          for (let j = 0; j < element.menus.length; j++) {
            const menu = element.menus[j];
            const name: string =
              menu && menu.name ? menu.name.toLowerCase() : '';
            if (name.includes(this.search.toLowerCase())) {
              menu.show = true;
              element.show = true;
            } else {
              menu.show = false;
              element.show = false;
            }
          }
          if (element.menus.filter((item) => item.show).length) {
            element.show = true;
          } else {
            element.show = false;
          }
        }
      }
    } catch (error) {
      throw error;
    }
  }
  changeCurrentFoodWithoutVariants(food) {
    const { currentGroupIndex, dataIndex } = this.getIndex(
      this.data,
      this.selectedMenuGroupCode,
      food.menuItemCode
    );
    this.data[currentGroupIndex].menus[dataIndex] = food;
    const foodInCartListIndex = this.cartList.findIndex(
      (item) => item.menuItemCode === food.menuItemCode
    );
    if (this.cartList[foodInCartListIndex]) {
      this.cartList[foodInCartListIndex].num = food.num;
    }
  }
  showFoodDetailHandle(item, selectedMenuGroupCode) {
    if (item.variants && item.variants.length) {
      item.note = '';
      item.num = 1;
      this.selectedFood = cloneDeep(item);
      this.showFoodDetail = true;
    } else {
      this.selectedFood = item;
      this.selectedMenuGroupCode = selectedMenuGroupCode;
      if (!item.note) {
        item.note = '';
      }
      if (!item.num) {
        item.num = 1;
      }
      this.addToCart(item);
    }
  }
  changeSelected(value) {
    this.search = '';
    this.tempSearch = '';
    this.selected = value;
    this.tempSelected = value;
  }
  changeSearch(value) {
    this.selected = '';
    this.tempSelected = '';
    this.search = value;
    this.tempSearch = value;
  }
  updateCartList(cartList) {
    this.cartList = cartList;
  }
  hideFoodDetailHandle() {
    this.showFoodDetail = false;
    this.selectedFood = {};
  }
  showCartHandle() {
    this.selected = '';
    this.search = '';
    this.showCart = true;
  }
  hideCartHandle() {
    if (!this.tempSearch) {
      this.selected = this.tempSelected;
    }
    if (!this.tempSelected) {
      this.search = this.tempSearch;
    }
    this.showCart = false;
  }
  addToCart(item) {
    item.showNote = true;
    if (item.variants && item.variants.length) {
      const cloneItem = cloneDeep(item);
      cloneItem.custome_id = new Date().getTime();
      this.cartList.push(cloneItem);
    } else {
      const cartItemIndex = this.cartList.findIndex(
        (cartItem) => cartItem.menuItemCode === item.menuItemCode
      );
      if (cartItemIndex < 0) {
        this.cartList.push(item);
      } else {
        this.cartList[cartItemIndex] = item;
      }
    }
    this.hideFoodDetailHandle();
  }
  updateThisData(item) {
    const { currentGroupIndex, dataIndex } = this.getIndex(
      this.data,
      item.menuGroupCode,
      item.menuItemCode
    );
    const currentMenu = this.data[currentGroupIndex].menus[dataIndex];
    currentMenu.num = item.num;
    currentMenu.note = item.note;
  }
  minusItem(item) {
    try {
      item.num = item.num - 1;
      const index = this.cartList.findIndex((cart) =>
        item.custome_id
          ? cart.custome_id === item.custome_id
          : cart.menuItemCode === item.menuItemCode
      );
      if (item.num <= 0) {
        let cartList = cloneDeep(this.cartList);
        this.updateThisData(item);
        cartList.splice(index, 1);
        this.cartList = cartList;
        return;
      }
      const cloneCartList = cloneDeep(this.cartList);
      if (cloneCartList.length) {
        cloneCartList[index].num = item.num;
      }
      this.cartList = cloneCartList;
      this.updateThisData(item);
      this.$forceUpdate();
    } catch (error) {
      throw error;
    }
  }
  plusItem(item) {
    item.num = item.num + 1;
    const cloneCartList = cloneDeep(this.cartList);
    const index = this.cartList.findIndex((cart) =>
      item.custome_id
        ? cart.custome_id === item.custome_id
        : cart.menuItemCode === item.menuItemCode
    );
    cloneCartList[index].num = item.num;
    this.cartList = cloneCartList;
    this.updateThisData(item);
    this.$forceUpdate();
  }
  changeNote(e, item, index) {
    this.updateThisData(item);
    const cart = cloneDeep(this.cartList);
    cart[index].note = e;
    this.cartList = cart;
  }
  deleteItem(index, item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let cartList = cloneDeep(this.cartList);
        let index = 0;
        if (item.custome_id) {
          index = this.cartList.findIndex(
            (cart) => cart.custome_id === item.custome_id
          );
        } else {
          index = this.cartList.findIndex(
            (cart) => cart.menuItemCode === item.menuItemCode
          );
        }
        item.num = 0;
        item.note = '';
        this.updateThisData(item);
        cartList.splice(index, 1);
        this.cartList = cartList;
      }
    });
  }
  changeInputValue(e, name) {
    this[name] = e.target.value;
  }
  refreshHandle() {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: 'You will lose your selected food',
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.loading = true;
        this.refrshData(1);
      }
    });
  }
  async refrshData(refresh) {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    );
    const localMenuGroups = localStorage.getItem('localMenuGroups');
    if (!localMenuGroups || localMenuGroups === 'undefined' || refresh) {
      await api
        .GetPosMenuList({
          outletCode: posOrderOutlet.value,
          orderType: this.orderType,
          orderSource: 'BO',
        })
        .then((res) => {
          if (!res.data.data.menuGroups) return (this.loading = false);

          try {
            this.originalData = res.data.data.menuGroups;
            this.data = res.data.data.menuGroups || [];
            sessionStorage.setItem('outletName', res.data.data.name);
            localStorage.setItem(
              'localMenuGroups',
              JSON.stringify(res.data.data.menuGroups)
            );
            sessionStorage.setItem('compareOutLet', res.data.data.outletCode);
          } catch (error) {
            this.$swal(constants.SOMETHING_WROING, '', constants.STATUS_ERROR);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.data = [];
          this.$swal(constants.SOMETHING_WROING, '', constants.STATUS_ERROR);
          this.loading = false;
        });
    } else {
      const menuGroup = JSON.parse(localMenuGroups);
      this.originalData = menuGroup;
      this.data = menuGroup;
      this.loading = false;
    }
    if (this.data) {
      this.options = this.data.filter(
        (item) => item.menus && item.menus.length
      );
    }
    try {
      for (let i = 0; i < this.data.length; i++) {
        const element = this.data[i];
        element.show = true;
        if (element.menus) {
          for (let j = 0; j < element.menus.length; j++) {
            const item = element.menus[j];
            item.show = true;
            item.menuGroupCode = element.menuGroupCode;
            item.showVariants = false;
          }
        }
      }
    } catch (error) {
      this.loading = false;
      throw error;
    }
    this.options.unshift({ menuGroupCode: '', description: 'All' });
    if (refresh) return this.clearCartList();
    const sessionCartListInfo = sessionStorage.getItem('cartListInfo');
    if (sessionCartListInfo && !this.cartList.length) {
      const { cartList } = JSON.parse(sessionCartListInfo);
      this.cartList = cartList;
      this.filterData(this.data);
    }
  }
  clearCartList() {
    this.cartList = [];
    sessionStorage.removeItem('cartListInfo');
    this.showCart = false;
    try {
      for (let i = 0; i < this.data.length; i++) {
        const element = this.data[i];
        if (element.menus) {
          for (let j = 0; j < element.menus.length; j++) {
            const item = element.menus[j];
            item.num = 0;
          }
        }
      }
    } catch (error) {
      throw error;
    }
  }
  async mounted() {
    (document.getElementById('pos-order') as any).parentNode.scrollTop = 0;
    const sessionOrderType: string = sessionStorage.getItem('order_type') || '';
    this.shortOrderType = sessionOrderType;
    switch (sessionOrderType) {
      case 'table-order':
        this.orderType = constants.TOP;
        break;
      case 'dine-in':
        this.orderType = constants.PPDI;
        break;
      case 'take-away':
        this.orderType = constants.PPTA;
        break;
      case 'delivery':
        this.orderType = constants.HMD;
        break;
      case 'room':
        this.orderType = constants.ROOM;
        break;
      default:
        this.orderType = constants.OTHERS;
        break;
    }
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    );
    const compareOutLet = sessionStorage.getItem('compareOutLet');
    const compareOrdertype = sessionStorage.getItem('compareOrdertype');
    if (posOrderOutlet && posOrderOutlet !== 'undefined') {
      if (
        String(posOrderOutlet.value) !== compareOutLet ||
        this.$route.query.type !== compareOrdertype
      ) {
        await this.refrshData(1);
      }
    }
    await this.refrshData(0);
    sessionStorage.setItem('pos-order-page', this.$route.fullPath);
    const showCart = sessionStorage.getItem('showCart');
    if (showCart) {
      this.showCart = true;
      sessionStorage.removeItem('showCart');
    }
    sessionStorage.setItem('compareOrdertype', (this.$route.query as any).type);
  }
}
